<template>
  <a-card :bordered="false" :title="title">
    <SearchListPage
      ref="pageList"
      :query-item-list="getQueryItemList()"
      :columns="getColumns()"
      :request-promise="getDataPromise"
      :query-params="queryParams"
      :button-items="['addButton']"
    >
      <a-button type="primary" style="margin-left: 20px" icon="plus" slot="addButton" @click="addGroupEvent">新建分组
      </a-button>
      <template slot="action" slot-scope="rowItem">
        <a style="margin-right: 10px" @click="editGroupEvent(rowItem.record)">编辑</a>
        <a-popconfirm v-if="rowItem.record.num<1" title="此操作将删除此分组, 是否继续?"
                      @confirm="deleteGroupEvent(rowItem.record)">
          <a>删除</a>
        </a-popconfirm>
      </template>
    </SearchListPage>
    <a-modal
      :title="groupForm.id?'编辑分组':'新建分组'"
      :visible="showAddDialog"
      :width="600"
      @ok="onSaveEvent"
      @cancel="showAddDialog = false">
      <a-form-model
        :model="groupForm"
        :rules="rules"
        ref="ruleForm"
        :label-col="{span:6}"
        :wrapper-col="{span:18}">
        <a-form-model-item label="分组名称" prop="groupName">
          <a-input v-model="groupForm.groupName" placeholder="请输入" :maxLength="30"/>
        </a-form-model-item>
        <a-form-model-item label="分组负责人">
          <a-select style="width: 100%" allowClear v-model="groupForm.verifierId" placeholder="请选择">
            <a-select-option v-for="item in verifierList" :key="item.value" :value="item.value">{{ item.key }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="备注" prop="remark">
          <a-textarea
            v-model="groupForm.remarks"
            :maxLength="500"
            placeholder="请输入"
            :auto-size="{ minRows: 5, maxRows: 10 }"/>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </a-card>
</template>

<script>
import SearchListPage from '@/customComponents/SearchListPage/SearchListPage'

export default {
  name: 'GroupingSetting',
  components: { SearchListPage },
  data() {
    return {
      title: '',
      showAddDialog: false,
      verifierList: [],
      queryParams: {
        selectedName: undefined,
        verifierId: undefined
      },
      groupForm: {
        groupName: '',
        verifierId: undefined,
        remarks: ''
      },
      rules: {
        groupName: [
          {
            required: true,
            message: '请输入分组名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    let pageParams = this.getPageParams()
    this.queryParams.couponId = pageParams.couponId
    this.title = `${pageParams.proName} > 核销设置 > 核销员分组`
  },

  mounted() {
  },
  methods: {
    getDataPromise(parameter) {
      console.error('queryParams', this.queryParams)
      console.error('parameter', parameter)
      return this.getHttpServices().getCouponService().post('couponVerifierGroup/getVerifierGroupPage', parameter)
    },
    getQueryItemList() {
      return [
        {
          name: '分组名称',
          keys: ['groupName'],
          type: 'input'
        }
      ]
    },
    getColumns() {
      return [
        {
          title: '分组名称',
          dataIndex: 'groupName'
        },
        {
          title: '成员数量',
          dataIndex: 'num'
        },
        {
          title: '备注',
          dataIndex: 'remarks'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '160px'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: '120px',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    deleteGroupEvent(item) {
      const url = `couponVerifierGroup/delVerifierGroup/${item.groupId}`
      this.getHttpServices().getCouponService().post(url)
        .then(res => {
          this.$message.success('删除成功！')
          this.$refs.pageList.refresh()
        }).catch(res => {
        this.showNetWorkErrorMessage(res)
      })
    },
    editGroupEvent(item) {
      const groupId = item.groupId
      Promise.all([this.getGroupDetail(groupId), this.getAllVerifierList(groupId)])
        .then(list => {
          console.error('==list==', list)
          this.verifierList = list[1] ? list[1] : []
          this.groupForm = {
            ...list[0],
            verifierId: list[0].verifierId ? list[0].verifierId : undefined
          }
          this.showAddDialog = true
        }).catch(reason => {
        console.error(reason)
        this.showNetWorkErrorMessage(reason)
      })
    },
    addGroupEvent() {
      this.groupForm = {}
      this.verifierList = []
      this.showAddDialog = true
    },

    onSaveEvent() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const submitParams = {
            ...this.groupForm,
            couponId: this.queryParams.couponId
          }
          this.getHttpServices().getCouponService().post('couponVerifierGroup/editVerifierGroup', submitParams)
            .then(list => {
              this.$message.success('保存成功')
              this.$refs.pageList.refresh(false)
              this.showAddDialog = false
            }).catch(reason => this.showNetWorkErrorMessage(reason))
        }
      })
    },
    getGroupDetail(groupId) {
      const url = `/couponVerifierGroup/getVerifierGroup/${groupId}`
      return this.getHttpServices().getCouponService().post(url)
    },
    getAllVerifierList(groupId) {
      const url = `couponVerifierGroup/getAllVerifierList/${groupId}`
      return this.getHttpServices().getCouponService().post(url)
    }
  }

}
</script>
<style scoped>
</style>